import { useLocation } from "react-router-dom";
import { AdPlaceholder } from "./AdPlaceholder";

const DISABLED_PREFIXES = ["/about", "/privacy", "/terms"];

export function ContentShell({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const showAd = !DISABLED_PREFIXES.some((prefix) => location.pathname?.startsWith(prefix));

  return (
    <div
      className={`mt-6 flex flex-col w-full ${
        showAd ? "xl:grid xl:grid-cols-[minmax(0,1fr)_300px] items-start gap-6 xl:gap-8" : "gap-6"
      }`}
    >
      <main className="min-w-0 w-full">{children}</main>
      {showAd && <AdPlaceholder />}
    </div>
  );
}
